<router-outlet></router-outlet>
<app-reload-app
  *ngIf="showReload$ | async"
  [minimumUI]="minimumUi$ | async"
  [currentUI]="currentUI"
></app-reload-app>
